import {useShowError} from "@hooks/useShowError/useShowError";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import {
    QUERY_KEY_PAGINATION_SIMPLE_SINGLE_VOYAGES,
    QUERY_KEY_SINGLE_VOYAGE_BY_ID,
    QUERY_KEY_SINGLE_VOYAGES
} from "@containers/singleVoyage/fetchingData/queryHooks/constants/queryKey";
import {
    IPropsGetByIdSingleVoyage,
    IPropsGetPaginationSimpleSingleVoyages,
    IPropsGetSingleVoyages
} from "@containers/singleVoyage/fetchingData/types";
import {
    getSingleVoyageByIdApi,
    getSingleVoyagesApi,
    getSingleVoyagesPaginationApi
} from "@containers/singleVoyage/fetchingData/api/api";

export const useGetSingleVoyagesQuery = ({
                                             params,
                                             enabled,
                                             voyageStatuses,
                                             refetchInterval
                                         }: {
    params: IPropsGetSingleVoyages,
    enabled?: boolean,
    voyageStatuses?: VoyageStatusSingleVoyage[],
    refetchInterval?: number
}) => {
    const {onShowError} = useShowError()

    return useQuery({
        queryFn: () => getSingleVoyagesApi({
            params,
            voyageStatuses,
            onError: onShowError
        }),
        queryKey: [
            QUERY_KEY_SINGLE_VOYAGES,
            params?.accountId,
            voyageStatuses?.join(',') || ''
        ],
        staleTime: 1000 * 60 * 30,
        enabled:(typeof  enabled === 'undefined' ? true : enabled) && !!params?.accountId,
        refetchInterval,
        placeholderData: keepPreviousData,
    });
}

export const useGetPaginationSimpleSingleVoyagesQuery = ({
                                                             params,
                                                             enabled,
                                                             voyageStatuses,
                                                             refetchInterval
                                                         }: {
    params: IPropsGetPaginationSimpleSingleVoyages,
    enabled?: boolean,
    voyageStatuses?: VoyageStatusSingleVoyage[],
    refetchInterval?: number
}) => {
    const {onShowError} = useShowError()

    return useQuery({
        queryFn: () => getSingleVoyagesPaginationApi({
            params,
            voyageStatuses,
            onError: onShowError
        }),
        queryKey: [
            QUERY_KEY_PAGINATION_SIMPLE_SINGLE_VOYAGES,
            params?.accountId,
            params?.page,
            params?.perPage,
            params?.searchValue || '',
            params?.order || '',
            params?.direction || '',
            voyageStatuses?.join(',') || ''
        ],
        staleTime: 1000 * 60 * 30,
        enabled:(typeof  enabled === 'undefined' ? true : enabled) && !!params?.accountId,
        refetchInterval,
        placeholderData: keepPreviousData,
    });
}


export const useGetByIdSingleVoyageQuery = ({
                                                params,
                                                refetchOnMount,
                                                refetchInterval,
                                            }: {
    params: IPropsGetByIdSingleVoyage,
    refetchOnMount?: 'always' | boolean,
    refetchInterval?: number,
}) => {
    const {onShowError} = useShowError()

    return useQuery({
        queryFn: () => getSingleVoyageByIdApi(params, onShowError),
        queryKey: [QUERY_KEY_SINGLE_VOYAGE_BY_ID, params?.voyageId],
        staleTime: 1000 * 60 * 30,
        enabled: !!params.voyageId,
        refetchOnMount,
        refetchInterval,
        placeholderData: keepPreviousData,
    });
}
